import { API_BASE_URL } from '../config/api';

export interface WeightMeasurement {
  id: string;
  clientId: string;
  clientName: string;
  measurementDate: string;
  weight?: number;
  waist?: number;
  chest?: number;
  hip?: number;
  arm?: number;
  thigh?: number;
  bodyFatPercentage?: number;
  muscleMass?: number;
  notes?: string;
  createdAt: string;
  updatedAt?: string;
}

export interface CreateWeightMeasurementRequest {
  clientId: string;
  clientName: string;
  measurementDate: string;
  weight?: number;
  waist?: number;
  chest?: number;
  hip?: number;
  arm?: number;
  thigh?: number;
  bodyFatPercentage?: number;
  muscleMass?: number;
  notes?: string;
  /** Diyetisyen danışan için ölçüm eklediğinde bildirim gönderilmesi için */
  dietitianId?: string;
  dietitianName?: string;
}

export interface UpdateWeightMeasurementRequest {
  measurementDate?: string;
  weight?: number;
  waist?: number;
  chest?: number;
  hip?: number;
  arm?: number;
  thigh?: number;
  bodyFatPercentage?: number;
  muscleMass?: number;
  notes?: string;
}

export interface CreateWeightMeasurementResponse {
  message: string;
  measurement: WeightMeasurement;
}

export interface UpdateWeightMeasurementResponse {
  message: string;
  measurement: WeightMeasurement;
}

export interface DeleteWeightMeasurementResponse {
  message: string;
}

export const weightMeasurementApi = {
  async getAllMeasurements(): Promise<WeightMeasurement[]> {
    const response = await fetch(`${API_BASE_URL}/weightmeasurements`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  },

  async getMeasurementById(id: string): Promise<WeightMeasurement> {
    const response = await fetch(`${API_BASE_URL}/weightmeasurements/${id}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  },

  async getMeasurementsByClient(
    clientId: string
  ): Promise<WeightMeasurement[]> {
    const response = await fetch(
      `${API_BASE_URL}/weightmeasurements/client/${clientId}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  },

  async getLatestMeasurementByClient(
    clientId: string
  ): Promise<WeightMeasurement | null> {
    const response = await fetch(
      `${API_BASE_URL}/weightmeasurements/client/${clientId}/latest`
    );
    if (!response.ok) {
      if (response.status === 404) {
        return null;
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  },

  async createMeasurement(
    measurementData: CreateWeightMeasurementRequest
  ): Promise<CreateWeightMeasurementResponse> {
    const response = await fetch(`${API_BASE_URL}/weightmeasurements`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(measurementData),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  },

  async updateMeasurement(
    id: string,
    measurementData: UpdateWeightMeasurementRequest
  ): Promise<UpdateWeightMeasurementResponse> {
    const response = await fetch(`${API_BASE_URL}/weightmeasurements/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(measurementData),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  },

  async deleteMeasurement(
    id: string
  ): Promise<DeleteWeightMeasurementResponse> {
    const response = await fetch(`${API_BASE_URL}/weightmeasurements/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  },
};
